import { MINIMUM_TIME_FOR_MANDATORY_BREAK_IN_HOURS } from "../Shift/constants";
import { formatBreakDuration } from "./formatBreakDuration";

interface FormatDurationWithBreakPartsParams {
  /**
   * Total shift duration in hours (including break)
   */
  totalDurationInHours: number;
  /**
   * Break duration in minutes
   */
  breakDurationInMinutes: number;
  /**
   * Whether the shift requires a break
   */
  requiresBreak: boolean;
  /**
   * Minutes elapsed since the start of the shift
   */
  minutesElapsed?: number;
}
/**
 * Formats a shift duration and returns separate parts for duration and break info
 * @returns Object with separate duration and break info strings
 */
export function formatDurationWithBreakParts(props: FormatDurationWithBreakPartsParams): {
  duration: string;
  breakInfo: string;
} {
  const { totalDurationInHours, breakDurationInMinutes, requiresBreak, minutesElapsed = 0 } = props;

  const totalDurationInMinutes = Math.round(totalDurationInHours * 60 - minutesElapsed);
  const totalHours = Math.floor(totalDurationInMinutes / 60);
  const totalMinutes = totalDurationInMinutes % 60;

  // Format total duration, omitting "00m"
  let duration = `${totalHours}h`;
  if (totalMinutes > 0) {
    duration += ` ${totalMinutes.toString().padStart(2, "0")}m`;
  }

  // Determine break info text
  let breakInfo = "";

  // Only show break for shifts that meet the minimum duration requirement
  if (
    !requiresBreak ||
    breakDurationInMinutes === 0 ||
    totalDurationInHours < MINIMUM_TIME_FOR_MANDATORY_BREAK_IN_HOURS
  ) {
    breakInfo = "no mandatory break";
  } else {
    const breakFormatted = formatBreakDuration(breakDurationInMinutes);
    breakInfo = `incl. ${breakFormatted} unpaid break`;
  }

  return { duration, breakInfo };
}
